import axios from 'axios';
// config
import { HOST_API_URL } from '../config';

// ----------------------------------------------------------------------

const axiosInstance = axios.create({ baseURL: HOST_API_URL });

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (!error.response) {
      return Promise.reject('Failed');
    }

    if (error.response.data) {
      return Promise.reject(error.response.data);
    }

    // The API answers a missing, invalid or expired bearer token with 401 and an
    // empty body, and an unknown URL with an empty 404. Without this the Try
    // panels would report either as a network failure.
    return Promise.reject({
      statusCode: error.response.status,
      message:
        error.response.status === 401
          ? 'Unauthorized - the token is missing, invalid or expired. Request a new one with Get Token.'
          : 'The API returned no response body.',
      errorCode: null,
      data: null,
    });
  }
);

export default axiosInstance;
